import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { EMPLOYEE_BLUE, PINK_RED, WHITE } from "../colors";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import HeightBox from "./HeightBox";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 721,
  height: 280,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  p: 4,
};

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 180,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  color: WHITE,
}));

export default function CustomModelForAssignRole(props) {
  const { message, okFunction, roles, openModel, cancelFunction, handleCancelModel } = props;
  const [activityType, setActivityType] = React.useState("");
  const [loading, setLoading] = useState(false);

  // After the api call setLoading should me make to false

  const handleChange = (event) => {
    setActivityType(event.target.value);
  };

  return (
    <Modal
      open={openModel}
      onClose={() => {
        setActivityType("");
        setLoading(false);
        handleCancelModel();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {message}
        </Typography>
        <HeightBox height={40} />
        <CustomSelect
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          onChange={handleChange}
          defaultValue={"x"}
        >
          <MenuItem disabled value={"x"}>
            Select role
          </MenuItem>
          {roles?.map((role) => (
            <MenuItem key={role.id} value={role.id} key={role.id}>
              {role.name}
            </MenuItem>
          ))}
        </CustomSelect>
        <HeightBox height={20} />
        <CustomButton
          style={{ backgroundColor: EMPLOYEE_BLUE }}
          disabled={loading}
          onClick={() => {
            setLoading(true);
            okFunction(activityType);
            setLoading(false);
          }}
        >
          {loading ? <CircularProgress size={15} /> : " Assign Role"}
        </CustomButton>
      </Box>
    </Modal>
  );
}
